import { render, staticRenderFns } from "./MoveDialog.vue?vue&type=template&id=b73136ac&scoped=true&"
import script from "./MoveDialog.vue?vue&type=script&lang=js&"
export * from "./MoveDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoveDialog.vue?vue&type=style&index=0&id=b73136ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73136ac",
  null
  
)

export default component.exports